(function () {
  'use strict';

  var config = window.THDDrop || {};
  var allowedFormId = 'Xnz2Nn';
  var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'source', 'campaign', 'ad_set', 'adset', 'creative'];
  var cartRemovalStarted = false;
  var cartRemovalFailed = false;
  var cartStateCheckPending = false;
  var cartStateCheckRunning = false;
  var cartStateCheckGeneration = 0;
  var analyticsOnceMemory = {};

  function safeSessionGet(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } }
  function safeSessionSet(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  function once(key, callback) {
    if (analyticsOnceMemory[key] || safeSessionGet(key)) return;
    analyticsOnceMemory[key] = true;
    safeSessionSet(key, '1');
    callback();
  }
  function captureAttribution() {
    var current = {};
    try { current = JSON.parse(safeSessionGet('thd-drop-attribution') || '{}'); } catch (_) {}
    var params = new URLSearchParams(window.location.search);
    attributionKeys.forEach(function (key) { if (params.has(key)) current[key] = params.get(key); });
    safeSessionSet('thd-drop-attribution', JSON.stringify(current));
    return current;
  }
  function properties() {
    var a = captureAttribution();
    return {
      drop: config.drop || '', experience: config.experience || '', page: window.location.pathname, city: config.city || '',
      source: a.source || a.utm_source || '', campaign: a.campaign || a.utm_campaign || '',
      ad_set: a.ad_set || a.adset || '', creative: a.creative || '',
      utm_source: a.utm_source || '', utm_medium: a.utm_medium || '',
      utm_campaign: a.utm_campaign || '', utm_term: a.utm_term || '',
      utm_content: a.utm_content || '', utm_id: a.utm_id || ''
    };
  }
  function klaviyoTrack(name, props) {
    window._learnq = window._learnq || [];
    window._learnq.push(['track', name, props]);
  }
  function focusForm(event) {
    var target = document.getElementById('thd-drop-form');
    if (!target) return;
    if (event) event.preventDefault();
    var trigger = event && event.target.closest('[data-thd-reveal-form]');
    if (trigger) {
      target.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      trigger.hidden = true;
      window.dispatchEvent(new Event('resize'));
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      var input = target.querySelector('input:not([type="hidden"]), button, [tabindex]');
      if (input) input.focus({ preventScroll: true }); else target.focus();
    }, 450);
  }
  function playV1Background(video) {
    if (!video || video.dataset.thdV1Autoplay !== 'true') return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    var result = video.play();
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }
  function prepareV1Background(video) {
    if (!video) return;
    if (video.dataset.thdV1PlaybackReady !== 'true') {
      video.dataset.thdV1PlaybackReady = 'true';
      video.addEventListener('loadedmetadata', function () { playV1Background(video); });
      video.addEventListener('canplay', function () { playV1Background(video); });
    }
    playV1Background(video);
  }
  function recoverV1Background(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('video[data-thd-v1-video]').forEach(prepareV1Background);
  }
  function suppressPopupCommands() {
    window._klOnsite = window._klOnsite || [];
    var originalPush = window._klOnsite.push.bind(window._klOnsite);
    window._klOnsite.push = function () {
      var args = Array.prototype.slice.call(arguments);
      var blocked = args.some(function (command) { return Array.isArray(command) && command[0] === 'openForm'; });
      return blocked ? window._klOnsite.length : originalPush.apply(null, args);
    };
    function removeExternalDialogs() {
      document.querySelectorAll('[role="dialog"], [data-testid="POPUP"], [data-testid="FLYOUT"], [data-testid="FULLSCREEN"]').forEach(function (node) {
        if (!node.closest('[data-thd-inline-form]') && (node.querySelector('[class*="klaviyo"]') || /klaviyo/i.test(node.className || ''))) node.remove();
      });
    }
    new MutationObserver(removeExternalDialogs).observe(document.documentElement, { childList: true, subtree: true });
    removeExternalDialogs();
  }
  function updateCountdown() {
    var el = document.querySelector('[data-thd-countdown]');
    var status = document.querySelector('[data-thd-countdown-status]');
    if (!el || !config.launchAt) return true;
    var launch = new Date(config.launchAt);
    var delta = launch.getTime() - Date.now();
    if (!Number.isFinite(delta)) { el.textContent = 'Launch time unavailable'; return true; }
    if (status && !status.dataset.initialized) {
      status.dataset.initialized = 'true';
      status.textContent = 'Countdown active. Drop launches ' + launch.toLocaleString() + '.';
    }
    if (delta <= 0) {
      el.textContent = 'The drop is live';
      if (status && status.dataset.state !== 'live') { status.dataset.state = 'live'; status.textContent = 'The drop is live.'; }
      return true;
    }
    var days = Math.floor(delta / 86400000);
    var hours = Math.floor(delta / 3600000) % 24;
    var minutes = Math.floor(delta / 60000) % 60;
    var seconds = Math.floor(delta / 1000) % 60;
    el.textContent = [days + 'D', hours + 'H', minutes + 'M', seconds + 'S'].join(' : ');
    return false;
  }
  function setCartStatus(message, failed) {
    document.querySelectorAll('[data-thd-cart-status]').forEach(function (node) { node.textContent = message; });
    document.querySelectorAll('[data-thd-drop-cart-error]').forEach(function (node) { node.hidden = !failed; });
    document.querySelectorAll('[data-thd-drop-cart-retry]').forEach(function (node) { node.hidden = !failed; });
  }
  function cartProtectionActive() {
    return config.cartLocked || cartStateCheckPending || document.querySelector('[data-thd-drop-checkout-lock]');
  }
  function lockCheckout() {
    if (!cartProtectionActive()) return;
    document.querySelectorAll('[data-thd-drop-checkout], [name="checkout"]').forEach(function (control) {
      if (!control.hasAttribute('data-thd-drop-lock-owned')) {
        control.setAttribute('data-thd-drop-lock-owned', '');
        control.setAttribute('data-thd-drop-was-disabled', control.disabled ? 'true' : 'false');
        control.setAttribute('data-thd-drop-original-name', control.getAttribute('name') || '');
      }
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
      control.removeAttribute('name');
    });
  }
  function unlockCheckout(cart) {
    if (cartProtectionActive()) return;
    var cartHasItems = !cart || Number(cart.item_count) > 0;
    document.querySelectorAll('[data-thd-drop-checkout]').forEach(function (control) {
      if (!control.hasAttribute('data-thd-drop-lock-owned')) return;
      var checkoutName = control.getAttribute('data-thd-drop-checkout-name') || control.getAttribute('data-thd-drop-original-name');
      if (cartHasItems) {
        control.disabled = false;
        control.removeAttribute('aria-disabled');
        if (checkoutName) control.setAttribute('name', checkoutName);
      } else {
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        control.removeAttribute('name');
      }
      control.removeAttribute('data-thd-drop-lock-owned');
      control.removeAttribute('data-thd-drop-was-disabled');
      control.removeAttribute('data-thd-drop-original-name');
    });
  }
  function protectedCartItems(cart) {
    return (cart.items || []).filter(function (item) {
      var handle = item.handle || item.product_handle;
      return handle === config.laHandle || handle === config.nyHandle;
    });
  }
  function renderNotificationProtection(items, failed) {
    var host = document.querySelector('[data-thd-drop-notification-safety]');
    if (!host) return;
    host.replaceChildren();
    items.forEach(function (item) {
      var marker = document.createElement('span');
      marker.hidden = true;
      marker.setAttribute('data-thd-drop-remove-key', item.key);
      host.appendChild(marker);
    });
    if (!items.length && !failed && !cartStateCheckPending) return;
    var lock = document.createElement('div');
    lock.className = 'thd-drop-cart-lock';
    lock.setAttribute('data-thd-drop-checkout-lock', '');
    var status = document.createElement('p');
    status.setAttribute('data-thd-cart-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.textContent = cartStateCheckPending ? 'Checking cart before checkout.' : 'Removing protected drop items. Checkout is locked until the cart is updated.';
    lock.appendChild(status);
    var error = document.createElement('p');
    error.setAttribute('data-thd-drop-cart-error', '');
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'assertive');
    error.hidden = !failed;
    error.textContent = 'We could not verify the cart. Checkout remains locked. Check your connection and retry.';
    lock.appendChild(error);
    var retry = document.createElement('button');
    retry.setAttribute('type', 'button');
    retry.setAttribute('data-thd-drop-cart-retry', '');
    retry.className = 'button button--secondary';
    retry.hidden = !failed;
    retry.textContent = 'Retry cart check';
    lock.appendChild(retry);
    host.appendChild(lock);
  }
  function runCartProtectionCheck() {
    var generation = cartStateCheckGeneration;
    cartStateCheckRunning = true;
    var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('cart verification failed'); return response.json(); })
      .then(function (cart) {
        if (generation !== cartStateCheckGeneration) return;
        var protectedItems = protectedCartItems(cart);
        cartStateCheckPending = false;
        cartRemovalStarted = false;
        if (!protectedItems.length) {
          config.cartLocked = false;
          renderNotificationProtection([], false);
          unlockCheckout(cart);
          return;
        }
        config.cartLocked = true;
        renderNotificationProtection(protectedItems, false);
        lockCheckout();
        removeProtectedCartLines();
      })
      .catch(function () {
        if (generation !== cartStateCheckGeneration) return;
        cartStateCheckPending = false;
        config.cartLocked = true;
        cartRemovalStarted = false;
        cartRemovalFailed = true;
        renderNotificationProtection([], true);
        lockCheckout();
      })
      .finally(function () {
        cartStateCheckRunning = false;
        if (generation !== cartStateCheckGeneration) runCartProtectionCheck();
      });
  }
  function refreshCartProtection() {
    cartStateCheckGeneration += 1;
    cartStateCheckPending = true;
    cartRemovalFailed = false;
    renderNotificationProtection([], false);
    lockCheckout();
    if (!cartStateCheckRunning) runCartProtectionCheck();
  }
  function removeProtectedCartLines() {
    lockCheckout();
    if (cartRemovalStarted || cartRemovalFailed) return;
    var keys = Array.from(document.querySelectorAll('[data-thd-drop-remove-key]'))
      .map(function (node) { return node.getAttribute('data-thd-drop-remove-key'); })
      .filter(function (key, index, list) { return key && list.indexOf(key) === index; });
    if (!keys.length) return;
    cartRemovalStarted = true;
    setCartStatus('Removing protected drop items. Checkout is locked until the cart is updated.', false);
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    keys.reduce(function (chain, key) {
      return chain.then(function () { return fetch(changeUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (response) { if (!response.ok) throw new Error('cart change failed'); return response.json(); }); });
    }, Promise.resolve())
      .then(function () { return fetch(cartUrl, { headers: { Accept: 'application/json' } }); })
      .then(function (response) { if (!response.ok) throw new Error('cart verification failed'); return response.json(); })
      .then(function (cart) {
        var blocked = (cart.items || []).some(function (item) { var handle = item.handle || item.product_handle; return handle === config.laHandle || handle === config.nyHandle; });
        if (blocked) throw new Error('protected cart line remains');
        window.location.reload();
      })
      .catch(function () {
        cartRemovalStarted = false;
        cartRemovalFailed = true;
        setCartStatus('Protected drop items could not be removed. Checkout remains locked.', true);
        lockCheckout();
      });
  }

  captureAttribution();
  recoverV1Background(document);
  document.addEventListener('DOMContentLoaded', function () { recoverV1Background(document); });
  window.addEventListener('pageshow', function () { recoverV1Background(document); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) recoverV1Background(document); });
  document.addEventListener('shopify:section:load', function (event) { recoverV1Background(event.target); });
  if (config.experience) {
    suppressPopupCommands();
    once('thd-drop-viewed:' + config.experience, function () { klaviyoTrack('THD Drop Landing Viewed', properties()); });
    document.addEventListener('click', function (event) { if (event.target.closest('[data-thd-scroll-form]')) focusForm(event); });
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail || {};
      if (detail.type !== 'submit' || detail.formId !== allowedFormId) return;
      var props = properties();
      once('thd-drop-signup:' + config.experience, function () { klaviyoTrack('THD Drop Signup', props); });
      document.querySelectorAll('[data-thd-success]').forEach(function (node) { node.hidden = false; });
    });
    if (!updateCountdown()) {
      var countdownTimer = window.setInterval(function () { if (updateCountdown()) window.clearInterval(countdownTimer); }, 1000);
    }
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-thd-drop-checkout]') && cartProtectionActive()) event.preventDefault();
    if (event.target.closest('[data-thd-drop-cart-retry]')) { cartRemovalFailed = false; refreshCartProtection(); }
  }, true);
  document.addEventListener('submit', function (event) {
    if (cartProtectionActive() && (event.target.id === 'cart' || event.target.id === 'CartDrawer-Form' || event.target.id === 'cart-notification-form')) event.preventDefault();
  }, true);
  document.addEventListener('thd:cart-notification-rendered', refreshCartProtection);
  lockCheckout();
  removeProtectedCartLines();
  new MutationObserver(function () { lockCheckout(); removeProtectedCartLines(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
